import type { ApiClient } from './client';
import type { VehicleHistoryEntry } from '../../types/vehicleHistory';

export const vehicleHistoryMethods = {
  async getVehicleHistory(params: { vehicle_id?: number; username?: string; slug?: string }): Promise<VehicleHistoryEntry[]> {
    const search = new URLSearchParams();
    if (params.vehicle_id) {
      search.set('vehicle_id', String(params.vehicle_id));
    } else if (params.username && params.slug) {
      search.set('username', params.username);
      search.set('slug', params.slug);
    } else {
      throw new Error('vehicle_id or username+slug required');
    }

    const response = await this.makeRequest<VehicleHistoryEntry[]>(
      `/vehicle_history_list.php?${search.toString()}`,
      { method: 'GET' }
    );
    if (response.success && Array.isArray(response.data)) return response.data;
    if (response.success) return [];
    throw new Error(response.error || response.message || 'Failed to load build timeline');
  },
} satisfies ThisType<ApiClient>;
